module.exports = __webpack_public_path__ + "static/media/xueshan_mobile.0cf2a384.png";